import { render, staticRenderFns } from "./landZhenProperty.vue?vue&type=template&id=13f57dce&scoped=true"
import script from "./landZhenProperty.vue?vue&type=script&lang=js"
export * from "./landZhenProperty.vue?vue&type=script&lang=js"
import style0 from "./landZhenProperty.vue?vue&type=style&index=0&id=13f57dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f57dce",
  null
  
)

export default component.exports